export default {
  data() {
    return {
      queryParams: {},
      pageFooterConfig: {
        show: true,
        list: [
          // {
          //   label: '',// 分号前的文字
          //   values: []分号后的文字数组
          // }
        ]
      }
    };
  },
  mounted() {
    this.addListListener();
  },
  methods: {
    viewExportData () {
      this.getDownloadDialog().show();
    },
    getDownloadDialog() {
      return this.$refs.downloadDialog || this.getListPage().getDownloadDialog();
    },
    handleDownloadParams({downloadParams}) {
      this.getListPage().setDownloadParams(downloadParams);
    },
    getListPage() {
      return this.$refs.listPage;
    },
    async reLoadData() {
      if (this.getListPage().getCurrentPage() !== 1) {
        this.getListPage().setCurrentPage(1);
      }
      return this.loadData();
    },
    handlePageCurrentChange(value) {
      this.loadData();
    },
    handleSizeChange(value) {
      this.reLoadData();
    },
    /**
     * @desc 该方法主要用于删除列表的数据后重新查询
     * @author LiangYongJia
     * @param size 被删除的记录数
     */
    updatePageData(size) {
      const listPage = this.getListPage();
      // 如果当前页只有一条数据，且当前页不是第一页，就要加载上一页
      const currentPage = listPage.getCurrentPage();
      const {fullData} = listPage.getTableData();
      if (fullData.length === 1 && currentPage !== 1) {
        listPage.setCurrentPage(currentPage - 1);
      }
      this.loadData();
    }
  },
  beforeDestroy() {
    this.removeListListener();
  }
};
